import React from "react";
import { TableHead } from "./TableHead";

export const TrHovered = (props) => {
	const { project, Visible } = props;

	if (!project && !Visible) {
		return null;
	}
	return (
		<tr
			className="tr-hovered"
			style={!Visible ? { display: "none" } : null}
		>
			<td>{project.name.name}</td>
			<td>{project.ville.name}</td>
			<td>{project.categories.name}</td>
			<td>{project.date.name}</td>
		</tr>
	);
};
